
import { defineComponent, reactive, inject, ref, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";
import EventService from '@/core/services/EventService';
import { errManager, cBoolean } from "@/core/config/Tools";

export default defineComponent({
    props:{
        setting: {
            type: Object,
            required: true,
            default: {}
        },
        item: {
            type: Object,
            required: false,
            default: {}
        }
    },
    setup(props, {emit}) {
        const store = useStore();
        const titleDialog = ref('')
        const gblDialog = inject<any>('gblDialog')
        const gblAction = inject<any>('gblAction')
        const gblPeriodo = inject < any > ('gblPeriodo')

        const loader = ref(false)
        const listTypes = ref<any>([])
        const listCategorie = ref<any>([])
        const listModality = ref<any>([])
        const listStatus = ref<any>([])

        const listRegions: any = computed < any > (() => {
            return store.getters.currentUser.regions;
        });

        const ruleFormRef = ref < FormInstance > ()
        const form = reactive <any>({
            periodo: null,
        })
        const rules = reactive < FormRules > ({
            name: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            tipo: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            level: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            modality: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            startdate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            enddate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            idseat: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            place: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            slug: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            mstatus: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const onOpen = () => {
            titleDialog.value = gblAction.value == 'new' ? 'Registrar evento' : 'Editar evento'
            listTypes.value = props.setting.types
            listCategorie.value = props.setting.categorie
            listModality.value = props.setting.modality
            listStatus.value = props.setting.status
        }

        const onOpened = () => {
            if(gblAction.value == 'edit')
                onEdit()
        }

        const onClosed = () => {
            titleDialog.value = ''
            resetForm(ruleFormRef.value)
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    (gblAction.value == 'new') ? save() : update()
                  
            });
        };

        const onEdit = async () => {
            loader.value = true
            await EventService.edit(props.item.idevent)
            .then((res) => {
                loader.value = false
                Object.assign(form, res.data)
                if(res.data){
                    form.register = cBoolean(form.register)
                    form.search_dni = cBoolean(form.search_dni)
                    form.allowed_max  = parseInt(form.allowed_max)
                }
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        const save = () => {
            loader.value = true
            form.periodo = gblPeriodo
            EventService.save(form)
            .then( (res) => {
                loader.value = false
                emit("onResponse", res.data)
            }).catch( ({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const update = () => {
            loader.value = true
            EventService.update(form.idevent, form)
            .then( (res) => {
                loader.value = false
                emit("onResponse", res.data)
            }).catch( ({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const getUrl = () => {
            form.slug = form.name.toLowerCase().replace(/\s+/g, '-')
        }


        return {
            gblDialog,
            gblAction,
            titleDialog,
            ruleFormRef,
            loader,
            form,
            rules,
            listTypes,
            listCategorie,
            listModality,
            listStatus,
            listRegions,
            //event
            onOpen,
            onOpened,
            onClosed,
            onEdit,
            resetForm,
            submitForm,
            cBoolean,
            getUrl
        }
        
    },
})
